import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-preference',
  templateUrl: './notification-preference.component.html',
  styleUrls: ['./notification-preference.component.css']
})
export class NotificationPreferenceComponent implements OnInit {  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/notification-preference/notification-preference.component.ts